type DocumentCountTrackerProps = {
  disableDecrement: boolean;
  disableIncrement: boolean;
  total: number;
  currentSelected: number;
  incrementFn: () => void;
  decrementFn: () => void;
  isOcr?: boolean;
};
function DocumentCountTracker({
  disableDecrement,
  disableIncrement,
  total,
  currentSelected,
  incrementFn,
  decrementFn,
  isOcr,
}: DocumentCountTrackerProps) {
  return (
    <div className="flex flex-row items-center gap-2 justify-center my-2">
      <button
        className={
          'bg-dark rounded-full h-6 w-6 flex items-center justify-center text-white disabled:bg-disabled'
        }
        disabled={disableDecrement}
        onClick={decrementFn}
      >
        <span className="k-icon k-i-arrow-chevron-left" />
      </button>
      <h3 className={'scan__doc__count'}>
        {isOcr ? 'Record' : 'Document'} {currentSelected} of {total}
      </h3>
      <button
        className={
          'bg-dark rounded-full h-6 w-6 flex items-center justify-center text-white disabled:bg-disabled'
        }
        disabled={disableIncrement}
        onClick={incrementFn}
      >
        <span className="k-icon k-i-arrow-chevron-right" />
      </button>
    </div>
  );
}

export default DocumentCountTracker;
